import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const FilterId = iotsUtils.fromList(constants.organization.search.filterIds);
